module.exports = __webpack_public_path__ + "f238498ded836b260247d0a2bf4cab79.svg";